"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
exports.default = vue_1.default.extend({
    name: 'PlayerTagDiscount',
    props: {
        amount: {
            type: Number,
        },
    },
    methods: {
        getAmount: function () {
            return this.amount * -1;
        },
    },
});
